/**
 * HDM Custom GTM Constants.
 * This file re-exports all constants from the core GTM constants file
 * and allows for overriding or adding new constants.
 */

// Re-export all constants from the core file.
export * from '@/core/data/constants/gtm';

// Define and export any custom or overridden values here.
export const ERROR = 'Error';
export const PAGE_DATA_LAYER = 'dataLayer';
export const GA4_EVENT_ADD_TO_WISH_LIST = 'add_to_wishlist';
export const GA4_EVENT_SELECT_ITEM = 'select_item';
export const GA4_EVENT_SEARCH_SUBMIT = 'search_submit';
export const GA4_EVENT_NULL_SEARCH = 'null_search';
export const GA4_EVENT_EXCEPTION = 'exception';
export const GA4_EVENT_REMOVE_COUPON = 'remove_coupon';

export const NOT_APPLICABLE = 'NA';
export const UNASSIGNED = 'unassigned';
export const HDM_PAGE_VIEW_EVENT = 'evPageViewInfo';
export const GA4_EVENT_PAGE_LOAD = 'page_load';
export const GA4_EVENT_ITEM_DELIVERY_PDP = 'item_delivery_pdp';
export const GA4_EVENT_ITEM_DELIVERY_PLP = 'item_delivery_plp';
export const GA4_EVENT_ITEM_DELIVERY_PURCHASE = 'item_delivery_purchase';
export const GA4_EVENT_ITEM_DELIVERY_CHECKOUT = 'item_delivery_checkout';

export const ERROR_TYPE_CLIENT = 'Client Error';
export const ERROR_TYPE_SERVER = 'Server Error';
export const ERROR_TYPE_THIRD_PARTY = 'Third-Party Error';
export const ERROR_TYPE_GENERIC_ERROR = 'Unclassified';
export const GA4_EVENT_ITEM_DELIVERY_CART = 'item_delivery_cart';
